import axios from 'axios';

export const workflowTwoApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/workflow-two`,
    headers: {
        'Content-Type': 'application/json'
    }
})